import { createModule } from '@evyweb/ioctopus';

import { subscribeDrawForecastUseCase, subscribeDrawUseCase } from '../../application/entry.js';
import { drawSubscriptionService } from '../../infrastructure/entry.browser.js';
import { subscribeDrawController, subscribeDrawForecastController } from '../../interface-adapters/entry.browser.js';
import { diSymbolMap } from '../types.js';

/**
 * Creates and configures the draw subscription module.
 *
 * @returns The configured draw subscription module.
 */
export function createDrawSubscriptionModule(): ReturnType<typeof createModule> {
  const drawSubscriptionModule = createModule();

  // Services
  drawSubscriptionModule
    .bind(diSymbolMap.IDrawSubscriptionService)
    .toHigherOrderFunction(drawSubscriptionService, [diSymbolMap.ISocketService]);

  // Use cases
  drawSubscriptionModule
    .bind(diSymbolMap.ISubscribeDrawForecastUseCase)
    .toHigherOrderFunction(subscribeDrawForecastUseCase, [diSymbolMap.IDrawSubscriptionService]);
  drawSubscriptionModule
    .bind(diSymbolMap.ISubscribeDrawUseCase)
    .toHigherOrderFunction(subscribeDrawUseCase, [diSymbolMap.IDrawSubscriptionService]);

  // Controllers
  drawSubscriptionModule
    .bind(diSymbolMap.ISubscribeDrawForecastController)
    .toHigherOrderFunction(subscribeDrawForecastController, [diSymbolMap.ISubscribeDrawForecastUseCase]);
  drawSubscriptionModule
    .bind(diSymbolMap.ISubscribeDrawController)
    .toHigherOrderFunction(subscribeDrawController, [diSymbolMap.ISubscribeDrawUseCase]);

  return drawSubscriptionModule;
}
